import * as React from 'react';
import { Eye, EyeClosed } from "@phosphor-icons/react";
const Visibility = (props: any) => {
  const {
    data,
    size,
    onClick
  } = props;
  const iconSize = size || 22;
  const paddingTop = size ? '' : 'pt-[3px]';
  let className = 'text-red-500';
  let icon = <EyeClosed weight="duotone" size={iconSize} />;
  if (data.show === true) {
    className = 'text-green-500';
    icon = <Eye size={iconSize} weight="duotone" />;
  }
  const handleClick = () => {
    if (onClick) {
      onClick(data.displayOrder);
    }
  };
  return <div role="button" tabIndex={0} aria-label={data.show === true ? "Hide event" : "Show event"} className={`cursor-pointer flex justify-center ${paddingTop} ${className}`} onClick={handleClick} onKeyDown={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  }} data-sentry-component="Visibility" data-sentry-source-file="visibility.tsx">{icon}</div>;
};
Visibility.displayName = 'Visibility';
export default Visibility;